import React from 'react';
import './ui.css';

/**
 * Примитивы кабинета. Существуют, чтобы состояния (hover/focus/active/disabled)
 * и шкалы задавались один раз, а не переписывались инлайном в каждом экране.
 */

type ButtonVariant = 'deal' | 'primary' | 'outline' | 'ghost' | 'danger';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** deal — главное денежное действие экрана, не больше одного. */
  variant?: ButtonVariant;
  size?: 'sm' | 'md';
  block?: boolean;
}

export function Button({
  variant = 'outline',
  size = 'md',
  block = false,
  className = '',
  type = 'button',
  ...rest
}: ButtonProps) {
  const classes = [
    'rz-btn',
    `rz-btn--${variant}`,
    size === 'sm' ? 'rz-btn--sm' : '',
    block ? 'rz-btn--block' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return <button type={type} className={classes} {...rest} />;
}

interface CardProps {
  /** Подпись секции: мелкая и разряжённая, не конкурирует с содержимым. */
  title?: string;
  action?: React.ReactNode;
  tone?: 'default' | 'raised' | 'flat';
  className?: string;
  children: React.ReactNode;
}

export function Card({ title, action, tone = 'default', className = '', children }: CardProps) {
  const classes = ['rz-card', tone !== 'default' ? `rz-card--${tone}` : '', className]
    .filter(Boolean)
    .join(' ');

  return (
    <section className={classes}>
      {(title || action) && (
        <header className="rz-card__head">
          {title && <h2 className="rz-card__title">{title}</h2>}
          {action}
        </header>
      )}
      {children}
    </section>
  );
}

interface ChipProps {
  tone?: 'default' | 'accent' | 'deal';
  children: React.ReactNode;
}

export function Chip({ tone = 'default', children }: ChipProps) {
  return <span className={`rz-chip${tone !== 'default' ? ` rz-chip--${tone}` : ''}`}>{children}</span>;
}
